import React, { useState } from 'react';
import '../../cssFiles/contactus.scss';
import Header from '../layouts/header';
import Footer from '../layouts/footer';
import { useEffect } from 'react';
// import contactusImg from '/images/contactus-image.png'; // Add this import

const ContactUs = () => {

    useEffect(() => {
      document.title = "Niveza - Contact Us";
    }, []);

  const [form, setForm] = useState({
    mobile: '',
    email: '',
    message: ''
  });

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    // Handle form submission logic here
    alert('Submitted!');
  };

  return (
    <div className="contactus-container">
      <Header/>
      <div className="contactus-card">
        <div className="contactus-form-section">
          <h2>Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="mobile"
              placeholder="Enter mobile number."
              value={form.mobile}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Enter email address."
              value={form.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="How can we help?"
              value={form.message}
              onChange={handleChange}
              required
            />
            <div className="contactus-submit-button">
              <button type="submit">Submit</button>
            </div>
          </form>
        </div>
        <div className="contactus-image-section">
          <img
            src={'/images/contactus-image.png'}
            alt="Teerth Technospace"
          />
        </div>
      </div>
      <div className="contactus-info">
        <span>Phone: <span className="contactus-phone">+91-96075-27770</span></span>
        <span>Email: <a href="mailto:support@niveza.in" className="contactus-email">support@niveza.in</a></span>
        <div>
          Address: Niveza India Pvt. Ltd. Office - A203, Teerth Technospace, Baner, Pune, 411045 Maharashtra, India
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;